"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.START = exports.SAGA = void 0;
var SAGA = 'apiFlow/authRefresh/SAGA';
exports.SAGA = SAGA;
var START = 'apiFlow/authRefresh/START';
exports.START = START;
var SUCCESS = 'apiFlow/authRefresh/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/authRefresh/FAILURE';
exports.FAILURE = FAILURE;